<template>
  <div class="sb-pagination__pages-container">
    <span class="sb-pagination__pages-label">Page</span>
    <SbPaginationSelect
      input-id="pagination-page-select"
      :hidden-label="i18n(props.locale, 'selectPage')"
      :aria-label="i18n(props.locale, 'pageSelect')"
      data-testid="page-select"
      :options="PagesOptions?.pages.slice(0, optionsLength)"
      :model-value="currentPage"
      navigational-select
      @change="onSelectChange"
      @load-more="increaseOptionsList"
    />
    <SbPaginationPagesText
      class="sb-pagination__pages-label"
      :pages="pages"
      is-placeholder
      :locale="locale"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref, onBeforeMount, watch } from 'vue'
import { SbPaginationSelect, SbPaginationPagesText } from './shared'
import { buildSelectOptions } from '../utils'
import PagesOptions from '../pagesOptiosList'
import i18n from '../../../i18n/index'

export type PagesContainer = {
  currentPage: number
  pages: number
  locale: string
}

const props = withDefaults(defineProps<PagesContainer>(), {
  currentPage: 1,
  pages: 10,
  locale: 'en',
})

const increaseNumber = 25

const emit = defineEmits<{
  (e: 'page-change', value: number): void
}>()

const optionsLength = ref(increaseNumber)

onBeforeMount(() => {
  if (props.currentPage > optionsLength.value) {
    optionsLength.value = props.currentPage + increaseNumber
  }

  createPagesOptions()
})

watch(
  () => props.pages,
  () => {
    createPagesOptions()
  },
)

const onSelectChange = (value: number): void => {
  emit('page-change', value)
  createPagesOptions()
}

const createPagesOptions = (): void => {
  PagesOptions.pages = buildSelectOptions(
    props.pages,
    (page: number) => i18n(props.locale, 'goToPage') + ` ${page}`,
  )
}

const increaseOptionsList = (): void => {
  optionsLength.value += increaseNumber
}
</script>
